import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=4c0a464d&scoped=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummary.vue?vue&type=style&index=0&id=4c0a464d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a464d",
  null
  
)

export default component.exports